import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {environment} from "../../../environments/environment";
import {AppConfigApiModel} from "../models/app-config.api-model";
import {ResultListApiModel} from "../models/result-list.api.model";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {QueryParamsService} from "../../core/services/query-params.service";

@Injectable({
  providedIn: 'root'
})
export class AppConfigRestService {
  private readonly resource = '/app_configs';
  private readonly currentResource = '/app-configs/current';

  constructor(
    private readonly http: HttpClient,
    private readonly params: QueryParamsService
  ) {
  }

  public getCurrent(channelCode: string, localeCode: string, bypassCache = false): Observable<AppConfigApiModel> {
    let headers = new HttpHeaders({'Accept-Language': localeCode});
    if (bypassCache) {
      headers = headers.set('x-cache-bypass', 'true');
    }
    return this.http.get<AppConfigApiModel>(`${environment.apiUrl}${this.currentResource}`, {
      headers,
      params: {channelCode}
    }).pipe(map((result: AppConfigApiModel) => plainToClass(AppConfigApiModel, result)));
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<AppConfigApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);

    return this.http.get<ResultListApiModel<AppConfigApiModel>>(`${environment.apiUrl}${this.resource}`, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<AppConfigApiModel>(AppConfigApiModel), result as object)));
  }

  public get(id: string): Observable<AppConfigApiModel> {
    return this.http.get<AppConfigApiModel>(`${environment.apiUrl}${this.resource}/${id}`)
      .pipe(map((result: AppConfigApiModel) => plainToClass(AppConfigApiModel, result)));
  }

  public create(payload: Partial<AppConfigApiModel>): Observable<AppConfigApiModel> {
    return this.http.post<AppConfigApiModel>(`${environment.apiUrl}${this.resource}`, payload)
      .pipe(map((result: AppConfigApiModel) => plainToClass(AppConfigApiModel, result)));
  }

  public update(config: AppConfigApiModel): Observable<AppConfigApiModel> {
    return this.http.put<AppConfigApiModel>(`${environment.apiUrl}${config['@id']}`, config)
      .pipe(map((result: AppConfigApiModel) => plainToClass(AppConfigApiModel, result)));
  }
}
